import { AfterViewInit, Component, Input } from "@angular/core";
import {
  AuthService,
  ConfigurationService,
  ShowToastrService,
  Utilities,
  LookupService,
  HttpCommonService,
} from "projects/sepidz-web-framework/src/lib/services";
import { UserLogin } from "projects/sepidz-web-framework/src/lib/models";
import { delay, take, tap } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserInformation } from "projects/sepidz-web-framework/src/lib/models/userinfo.model";
import { UntypedFormGroup, Validators, UntypedFormControl } from "@angular/forms";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Router } from "@angular/router";
import * as moment from "jalali-moment";

import { CallinfoComponent } from "projects/sepidz-web-framework-shell/src/lib/@theme/components/header/callinfo/callinfo.component";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { InfoValidation } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { IndexedDbService } from "projects/sepidz-web-framework/src/lib/services/indexed-db.service";
@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements AfterViewInit {
  userLogin = new UserLogin();
  isLoading = false;
  group: UntypedFormGroup;
  public today: string;
  users: UserInformation[];
  allUser: any[];
  ngUnsubscribe = new Subject<void>();
  arr: any = [1, 2];
  showPassword: boolean = false;
  showNumber: boolean = false;
  customHeight: number;
  invalidInfo: InfoValidation;
  @Input()
  isModal = false;

  currentInformation = this.authService?.currentInformation();
  isSepidzUser = false;

  constructor(
    private sts: ShowToastrService,
    protected selectorService: SelectorService,
    private authService: AuthService,
    private configurations: ConfigurationService,
    private lookupService: LookupService,
    private dialogService: SimpleModalService,
    private httpCommonService: HttpCommonService,
    private router: Router,
    public commmon: CommonService,
    public indexedDbService: IndexedDbService
  ) {}

  public ngAfterViewInit(): void {
    this.customHeight = 50;
  }

  public ngOnInit(): void {
    this.setGroup();
    this.getLoginRefresh();
    this.getUsers();
    this.setToday();
    this.commmon.setTheme("sepidz");
    this.commmon.updateSettings();
  }

  public ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  public onDisplayNameChanges(): void {
    const IdValue = this.group?.controls["Id"].value;
    this.isSepidzUser = this.users?.find((x) => x.Id === IdValue)?.UserName === "SepidzUser";
    const currentUserInfo = this.authService.currentUserInfo;
    if (IdValue && IdValue === currentUserInfo?.Id && currentUserInfo?.RememberMe) {
      this.group.controls["Password"].setValue(currentUserInfo?.Password);
      this.group.controls["RememberMe"].setValue(currentUserInfo?.RememberMe);
    } else this.group.controls["Password"].setValue(undefined);
  }

  public onSendCode(): void {
    if (!this.isSepidzUser) return;
    let api: string = `Authorization/SendCode?PhonNumber=${this.group.controls["PhoneNumber"].value}`;
    this.httpCommonService
      .get(api)
      .pipe(take(1))
      .subscribe(
        (x: number) => {},
        (error) => this.sts.showDialog(`${Utilities.getHttpResponseMessage(error)}`, "خطا در ارسال کد")
      );
  }
  public login() {
    if (this.invalidInfo && this.invalidInfo.Status != 1) {
      this.sts.showDialog(this.invalidInfo.Message, "خطا");
      return;
    }
    this.isLoading = true;
    if (this.isSepidzUser && !this.group.value.PhoneNumber) {
      this.sts.showDialog("شماره تلفن الزامیست.", "پیغام خطا");
      this.isLoading = false;
      return;
    }
    this.sts.showToast("info", "ورود به سیستم", "در حال ورود به سیستم");
    this.httpCommonService
      .create("Authorization/Login", this.group.getRawValue())
      .pipe(take(1))
      .subscribe(
        (user) => {
          let FindLoginUser: any = this.users.find((f) => f.Id === this.group.value.Id);
          this.userLogin.Id = FindLoginUser.Id;
          this.userLogin.UserName = FindLoginUser.UserName;
          this.authService.localStorage.savePermanentData(this.group.controls["BranchId"].value, "BranchId");
          this.authService.login(this.userLogin, user);
          this.getComputerName();
          this.sts.showToast("success", "ورود به سیستم", `خوش آمدید ${FindLoginUser.DisplayName}!`);
          this.lookupService.getall();
          this.authService.getLoginUserRoles(FindLoginUser.Name).then(() => {
            this.router.navigate([""]);
            this.authService.currentFiscalYear;
            this.isLoading = false;
          });
        },
        (error) => {
          this.isLoading = false;
          if (Utilities.checkNoNetwork(error)) {
            this.sts.showToast("danger", Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail + "  " + error);
            this.offerAlternateHost();
          } else {
            this.isLoading = false;
            let errorMessage = Utilities.getHttpResponseMessage(error);
            if (errorMessage) {
              this.sts.showDialog(`${errorMessage}`, "پیغام خطا");
            } else
              this.sts.showDialog(
                "هنگام ورود به سیستم یک خطا رخ داد، لطفا بعدا دوباره امتحان کنید.: " + Utilities.getResponseBody(error),
                "پیغام خطا"
              );
            this.authService.logout();
          }
        }
      );
  }

  public onBranchChanged(): void {
    this.group.controls["Id"].setValue(undefined);
    this.users = [];
    this.userLogin.Id = null;
    if (this.allUser) {
      let users: UserInformation[] = [];
      const branchId = this.group.get("BranchId").value;
      this.allUser.forEach((fe) => {
        if (fe.IsEnabled && fe.Branches.some((s) => s.BranchId === branchId && s.IsActive)) users.push(fe);
      });
      this.users = users;
    }
  }

  public onBranchClear(): void {
    this.users = null;
    this.userLogin.Id = null;
  }

  public completeBranchData($event: any): void {
    this.isLoading = false;
    if (
      $event?.data?.length > 0 &&
      this.currentInformation &&
      !this.currentInformation?.BranchingLightEnabled &&
      !this.currentInformation?.BranchingAdvancedEnabled &&
      !this.currentInformation?.RestaurantCallCenter
    ) {
      this.group.controls["BranchId"].setValue($event?.data[0].Id);
      this.group.controls["BranchId"].disable();
    }
  }

  public showInfo(): void {
    this.dialogService.open(CallinfoComponent, { errorMessage: "NotFound!!!" }, { closeOnClickOutside: false, autoFocus: true, closeOnEscape: true });
  }

  public onShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  public onShowNumber(): void {
    this.showNumber = !this.showNumber;
  }

  private getLoginRefresh(): void {
    this.httpCommonService
      .get("Authorization/GetInfo")
      .pipe(take(1))
      .subscribe((info: InfoValidation) => {
        if (info.Status != 1) {
          this.sts.showDialog(info.Message, "خطا");
          this.invalidInfo = info;
        }
        this.clearIndexedDbItems();
      });
  }

  private clearIndexedDbItems(): void {
    this.indexedDbService.clear("FrontOffice", "InvDaily");
    this.indexedDbService.clear("FrontOffice", "Categories");
  }

  private getUsers(): void {
    this.authService
      .getBranchUsers()
      .pipe(
        take(1),
        tap((users) => {
          if (users) {
            this.users = [];
            let _branchFilterUser: UserInformation[] = [];
            const branchId = this.group.get("BranchId").value;
            this.allUser = users;
            users.forEach((fe) => {
              if (fe.IsEnabled && fe.Branches.some((s) => s.BranchId === branchId && s.IsActive)) _branchFilterUser.push(fe);
            });
            this.users = _branchFilterUser;
          }
        }),
        delay(2000)
      )
      .subscribe(() => {
        if (!this.currentInformation) this.currentInformation = this.authService?.currentInformation();
      });
  }

  private setGroup(): void {
    let group: any = {
      Password: new UntypedFormControl(undefined, [Validators.required, Validators.minLength(3)]),
      Id: new UntypedFormControl(undefined, Validators.required),
      RememberMe: new UntypedFormControl(this.authService.rememberMe, Validators.required),
      BranchId: new UntypedFormControl(undefined, Validators.required),
      PhoneNumber: new UntypedFormControl(undefined),
    };
    this.group = new UntypedFormGroup(group);
  }

  private setToday() {
    this.today = moment().locale("fa-IR").format("dddd، jDD jMMMM jYYYY").toString();
  }

  private getComputerName(): void {
    this.httpCommonService
      .get("LocalSetting/GetMachinName")
      .pipe(take(1))
      .subscribe((data) => {
        this.commmon.storage.savePermanentData(data["ComputerName"], ClearableCache.ComputerName);
      });
  }

  private offerAlternateHost(): void {
    this.isLoading = false;
    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.sts.showDialog(
        "کاربر عزیز!  به نظر می رسد که سرویس وب شما برقرار نمی شود,لطفا یک بار از سیستم خارج و مجدد وارد شود... ",
        "پیغام خطا",
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.sts.showToast("warning", "API تغییر کرده است!", "API وب هدف به این تغییر داده شده است: " + value);
        }
      );
    }
  }
}
